export default "__VITE_ASSET__DyxVHtBT__"